export function isSourceWithOptions(source) {
  return Boolean(source.source);
}
export function isSourceGroupWithOptions(source) {
  return Boolean(source.sources);
}
export function isSource(source) {
  return !Array.isArray(source);
}
export function isSourceArray(source) {
  return Array.isArray(source);
}